export default {
  // Vino
  Filtro_Fasi_Vino: 'Fasi',
  Filtro_Soluzioni_Vino: 'Soluzioni',
  Filtro_Tipologia_Vino: 'Tipologia vino',
  Filtro_Certificazioni_Vino: 'Certificazioni',
  Filtro_Tipologia_Prodotto_Vino: 'Tipologia Prodotto',
  // Birra
  Filtro_Stili_Birra: 'Stili',
  Filtro_Fermentazione_Birra: 'Fermentazione',

  // Fasi
  Fermentazione: 'Fermentazione',
  Affinamento: 'Affinamento',
  Chiarifica: 'Chiarifica',
  Finissaggio: 'Finissaggio',
  Spumantizzazione: 'Spumantizzazione',
  'In vigna': 'In Vigna',
  'Mosto/Pigiatura': 'Mosto/Pigiatura',
  Stabilizzazione: 'Stabilizzazione',
  Uva: 'Uva',

  // Soluzioni
  'Aumentare la shelf life': 'Aumentare la shelf life',
  'Per fermentazioni difficili': 'Per fermentazioni difficili',
  'Prevenzione e cura dal bret': 'Prevenzione e cura dal brett',
  'Prevenzione e cura ossidazioni': 'Prevenzione e cura ossidazioni',
  'Prevenzione e cura riduzioni lieviti Atecnos':
    'Prevenzione e cura riduzioni lieviti Atecnos',
  'Produzione acido malico': 'Produzione acido malico',
  'Proteggere il colore': 'Proteggere il colore',
  'Arresti fermentativi': 'Arresti fermentativi',
  'Degradazione acido malico': 'Degradazione acido malico',
  'Per il vigneto': 'Per il vigneto',
  'Proteggere le uve in fase di raccolta':
    'Proteggere le uve in fase di raccolta',
  'Raggiungere la stabilità tartarica': 'Raggiungere la stabilità tartarica',

  // Tipologia vino
  Bianchi: 'Bianchi',
  Rossi: 'Rossi',
  Rosati: 'Rosati',
  Spumantizzati: 'Spumantizzati',
  'Senza solfiti': 'Senza solfiti',
  Aromatici: 'Aromatici',
  Dolci: 'Dolci e passiti',

  // Certificazioni
  'ICEA Prodotto Biologico': 'ICEA Prodotto Biologico',

  // Tipologia Prodotto
  'Lieviti Saccharomyces': 'Lieviti Saccharomyces',
  'Lieviti non Saccharomyces': 'Lieviti non Saccharomyces',
  'Attivanti secchi': 'Attivanti secchi',
  'Autolisati in crema Atecnos': 'Autolisati in crema Atecnos',
  'Batteri lattici': 'Batteri lattici',
  'Da affinamento': 'Da affinamento',
  'In fermentazione': 'In fermentazione',
  'In finissaggio': 'In finissaggio',
  'Per uve e mosti': 'Per uve e mosti',
  'Schizosaccharomyces pombe': 'Schizosaccharomyces pombe',
  'Super anti-ossidanti': 'Super anti-ossidanti',

  // Stili Birra
  'English Barleywine': 'English Barleywine',

  'English IPA': 'English IPA',

  'Imperial Stout': 'Imperial Stout',

  'Belgian Pale Ale': 'Belgian Pale Ale',

  'English Brown Ale': 'English Brown Ale',

  'New England IPA': 'New England IPA',

  'Scottish Heavy': 'Scottish Heavy',

  Stout: 'Stout',

  Witbier: 'Witbier',

  'American IPA': 'American IPA',

  'Belgian And French Ale': 'Belgian And French Ale',

  'Belgian Blonde Ale': 'Belgian Blonde Ale',

  'Belgian Dark Strong Ale': 'Belgian Dark Strong Ale',

  'Belgian Strong Ale': 'Belgian Strong Ale',

  'Dry Stout': 'Dry Stout',

  Dubbel: 'Dubbel',

  'English Old Ale': 'English Old Ale',

  'Imperial IPA': 'Imperial IPA',

  'Oatmeal Stout': 'Oatmeal Stout',

  Saison: 'Saison',

  'Scottish Light': 'Scottish Light',

  Tripel: 'Tripel',

  'Vienna Lager': 'Vienna Lager',

  Bock: 'Bock',

  Doppelbock: 'Doppelbock',
  Marzen: 'Marzen',
  'Münchener dunkel': 'Münchener dunkel',
  Oktoberfestbier: 'Oktoberfestbier',
  'Traditional bock': 'Traditional bock',
  Weiss: 'Weiss',
  Pils: 'Pils',
  'Strong English Ale': 'Strong English Ale',
  IPA: 'IPA',
  'Juicy IPA': 'Juicy IPA',
  'Pale ale': 'Pale ale',
  Ale: 'Ale',
  'Amber Lager': 'Amber Lager',
  'American Lager': 'American Lager',
  'Dark Lager': 'Dark Lager',
  Lambic: 'Lambic',
  'Birre speciali': 'Birre speciali',
  'Birre speziate': 'Birre speziate',
  'Birre aromatiche': 'Birre aromatiche',
  'Rifermentazioni in bottiglia': 'Rifermentazioni in bottiglia',
  Porter: 'Porter',
  'Fruit Beer': 'Fruit Beer',
  'American Stout': 'American Stout',
  'American Pale Ale': 'American Pale Ale',
  'American Amber Ale': 'American Amber Ale',
  'American Brown Ale': 'American Brown Ale',
  'American Ale': 'American Ale',
  'American Wheat Ale': 'American Wheat Ale',
  'Berliner Weisse': 'Berliner Weisse',
  'Bière De Garde': 'Bière De Garde',
  'Dusseldorf Altbier': 'Dusseldorf Altbier',
  'German Brown': 'German Brown',
  Kolsch: 'Kolsch',
  'Scottish Heavy': 'Scottish Heavy',
  'Traditional bock': 'Traditional bock',
  'Belgian Dubbel': 'Belgian Dubbel',

  // Fermentazione Birra
  'Alta fermentazione': 'Alta Fermentazione',
  'Bassa fermentazione': 'Bassa Fermentazione',
}
